import { createSelector } from 'reselect';

import selectPrivacyModeEnabled from 'app-components/hooks/privacyMode/selectPrivacyModeEnabled';
import type RootState from 'app-components/utils/redux-store/rootState';

import { ACHIEVEMENTS_REDUCER_KEY } from './achievementsTypes';

type State = Pick<RootState, typeof ACHIEVEMENTS_REDUCER_KEY>;

const KNOWN_ACHIEVEMENT_ID__ASSET_ACCUMULATOR = '8000000000'; // confirmed to be static

export const getResourceStore = (state: State) => state[ACHIEVEMENTS_REDUCER_KEY];
export const getAchievementsById = (state: State) => getResourceStore(state)?.resourcesById;
export const getLoadPending = (state: State) => getResourceStore(state).loadPending;
export const getIsLoading = (state: State) => getResourceStore(state).isLoading;
export const getError = (state: State): unknown => getResourceStore(state).error;

export const getAchievementsBySortId = createSelector(
  getAchievementsById,
  selectPrivacyModeEnabled,
  (achievements, privacyModeEnabled) =>
    achievements
      ?.toList()
      .sortBy((a) => Number(a.sortId))
      .filter(
        (achievement) =>
          achievement?.state === 'ACTIVE' &&
          /* block asset accumulator on privacy mode */
          (!privacyModeEnabled || achievement.knownAchievementId !== KNOWN_ACHIEVEMENT_ID__ASSET_ACCUMULATOR),
      ),
);

export const getAchievementById = createSelector(
  getAchievementsById,
  (_state: unknown, props: { id: string }) => props.id,
  (achievements, id) => achievements?.get(id.toString()),
);
